(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["mpc-quick-reorder"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('mpc-quick-reorder')) {
  customElements.define('mpc-quick-reorder', class extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;
      this.querySelector('form')?.addEventListener('submit', async (event) => {
        event.preventDefault();
        if (this.busy) return;
        const feedback = this.querySelector('.mpc-reorder__feedback');
        const message = this.querySelector('[data-reorder-message]');
        feedback.hidden = true;
        const quantities = new Map();
        for (const row of this.querySelectorAll('[data-reorder-row]')) {
          const selected = row.querySelector('[data-reorder-select]');
          if (selected.disabled || !selected.checked) continue;
          const input = row.querySelector('[data-reorder-quantity]');
          if (!input.reportValidity()) return;
          const id = row.dataset.variantId;
          const quantity = Number(input.value);
          if (!id || !Number.isSafeInteger(quantity) || quantity < 1) return;
          quantities.set(id, (quantities.get(id) || 0) + quantity);
        }
        if (!quantities.size) {
          message.textContent = this.dataset.selectMessage;
          feedback.hidden = false;
          return;
        }
        this.busy = true;
        const button = this.querySelector('button[type=submit]');
        button.disabled = true;
        this.setAttribute('aria-busy', 'true');
        try {
          const response = await fetch(this.dataset.addUrl, {
            method: 'POST',
            headers: {'Content-Type': 'application/json', 'Accept': 'application/json'},
            body: JSON.stringify({items: Array.from(quantities, ([id, quantity]) => ({id, quantity}))})
          });
          if (!response.ok) throw new Error('cart');
          window.location.assign(this.dataset.cartUrl);
        } catch {
          message.textContent = this.dataset.errorMessage;
          feedback.hidden = false;
          this.busy = false;
          button.disabled = false;
          this.removeAttribute('aria-busy');
        }
      });
    }
  });
}

  } catch(e) { console.error(e); }
})();
})();
